import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const apiClient = axios.create({ baseURL: API });

apiClient.interceptors.request.use((cfg) => {
    const token = localStorage.getItem("jassi_token");
    if (token) cfg.headers.Authorization = `Bearer ${token}`;
    return cfg;
});

apiClient.interceptors.response.use(
    (r) => r,
    (err) => {
        if (err?.response?.status === 401 && typeof window !== "undefined") {
            const onAdmin = window.location.pathname.startsWith("/admin");
            if (onAdmin && !window.location.pathname.startsWith("/admin/login")) {
                localStorage.removeItem("jassi_token");
                window.location.href = "/admin/login";
            }
        }
        return Promise.reject(err);
    }
);

// Convert relative /api/uploads paths to absolute URLs
export const resolveUrl = (u) => {
    if (!u) return u;
    if (u.startsWith("http")) return u;
    return `${BACKEND_URL}${u}`;
};

export const uploadFile = async (file) => {
    const fd = new FormData();
    fd.append("file", file);
    const r = await apiClient.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
    return r.data; // { url, filename }
};

export const formatApiError = (err) => {
    const d = err?.response?.data?.detail;
    if (!d) return err?.message || "Something went wrong";
    if (typeof d === "string") return d;
    if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(" ");
    return String(d);
};
